/** Customer-facing order id: PR- + 8 digits, never starting with 0. */
export function friendlyOrderNumber(stripeId: string): string {
  if (!stripeId) return '';
  let hash = 2166136261;
  for (let i = 0; i < stripeId.length; i += 1) {
    hash ^= stripeId.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  const n = 10_000_000 + ((hash >>> 0) % 90_000_000);
  return `PR-${n}`;
}
